import {doc} from "firebase/firestore";
import {postCollectionRef} from "@/shared/firebase_utils";

class Post {
	constructor({ id = "", multiConnectEventId = "", type = "", createdOn = null }) {
		(this.id = id || ""),
			(this.multiConnectEventId = multiConnectEventId || ""),
			(this.type = type || ""),
			(this.createdOn = createdOn || null);
	}

	toFireStore(){
		return{
			multiConnectEventId: this.multiConnectEventId || "",
			type: this.type || "",
			createdOn: this.createdOn || null
		}
	}

	generateId(){
    //Create an event id
    if(this.id == ''){
      let postDocRef = doc(postCollectionRef);
      this.id = postDocRef.id;
    }
   }
};

export default Post;